import { IFRAME_SEARCH_PARAM_KEYS } from '@/constants/iframe'
import { getWorldsDomain } from '@/lib/configs'
import { buildIframeUrl } from '@/lib/iframe'
import { useParams, useSearchParams } from 'next/navigation'

export function useMobileWorldRedirectUrlBuilder() {
  const searchParams = useSearchParams()
  const { roomId } = useParams()

  const baseQueryParams = Object.fromEntries(searchParams.entries())

  return ({ isFull3d }: { isFull3d?: boolean } = {}) => {
    return buildMobileWorldRedirectUrl({
      roomId: roomId as string,
      isFull3d,
      otherParams: baseQueryParams,
    })
  }
}

function buildMobileWorldRedirectUrl({
  roomId,
  isFull3d,
  otherParams = {},
}: {
  roomId: string
  isFull3d?: boolean
  otherParams: Record<string, string>
}): string {
  //const worldsDomain = `https://localhost:8080`
  const worldsDomain = `https://${getWorldsDomain()}`
  const baseUrl = `${worldsDomain}/${roomId}`

  if (isFull3d) {
    otherParams[IFRAME_SEARCH_PARAM_KEYS.FULL3D] = ''
  } else {
    delete otherParams[IFRAME_SEARCH_PARAM_KEYS.FULL3D]
  }

  otherParams[IFRAME_SEARCH_PARAM_KEYS.VRAM_LIMIT_PASSED] = ''

  return buildIframeUrl(baseUrl, { otherParams })
}
